import { StyleSheet } from "react-native";
import { theme } from "@clearabee/ui-library-native";

export const styles = StyleSheet.create({
  link: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing.medium,
    height: 75,
  },
  subheading: {
    textTransform: "uppercase",
    marginBottom: theme.spacing.xsmall2,
  },
  noPreviousOrders: {
    textAlign: "center",
    padding: theme.spacing.small,
    paddingVertical: theme.spacing.medium,
  },
  tableRow: {
    height: theme.spacing.xlarge2,
  },
  viewJob: {
    fontSize: theme.fontDefaults.small.fontSize,
    lineHeight: theme.fontDefaults.xsmall.lineHeight,
  },
  headingWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: theme.spacing.small,
  },
});
